import { flow, pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import {
  addVersionForUpdate, createAuthorizedDeleteRequest,
  createAuthorizedGetRequest, createAuthorizedHeadRequest,
  createAuthorizedPostRequest, createAuthorizedPutRequest, decode,
  decodeId,
  fetchApi, fetchUnparsedApi,
  setBody, setQuery, Versioned,
} from '@/services/api';
import { intoSendable } from '@/services/api/resources/issueTemplate/transform';
import { IssueTemplateEditable } from '@/ui/DTO';
import {
  encodeListIssueTemplateQuery,
  issueTemplateListCodec,
  ListIssueTemplateQuery,
} from '@/services/api/resources/issueTemplate';

const baseUrl = '/v2/issue-templates';
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const create = (issueTemplate: IssueTemplateEditable) => pipe(
  baseUrl,
  createAuthorizedPostRequest,
  map(setBody(intoSendable(issueTemplate))),
  chain(fetchApi),
  chain(decodeId),
);

export const list = (query: ListIssueTemplateQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeListIssueTemplateQuery(query))),
  chain(fetchApi),
  chain(decode(issueTemplateListCodec)),
);

export const update = (id: number, issueTemplate: Versioned<IssueTemplateEditable>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(issueTemplate.version)),
  map(setBody(intoSendable(issueTemplate.data))),
  chain(fetchApi),
);

export const remove = (id: number) => pipe(
  id,
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const head = flow(
  recordUrl,
  createAuthorizedHeadRequest,
  chain(fetchUnparsedApi),
);
